import { SelectionState, SelectionActionTypes, ADD_SELECTION, REMOVE_SELECTION, CLEAR_SELECTION } from './types'

const initialState: SelectionState = {
  selection: []
}

export function selectionsReducer(state = initialState, action: SelectionActionTypes): SelectionState {
  switch (action.type) {
    case ADD_SELECTION:
      const containsItem = state.selection.find((item) => item.title === action.item.title) !== undefined
      if (containsItem) {
        return state
      }

      return {
        ...state,
        selection: [...state.selection, action.item]
      }

    case CLEAR_SELECTION:
      return {
        ...state,
        selection: []
      }

    case REMOVE_SELECTION:
      return {
        ...state,
        selection: state.selection.filter((item) => item.title !== action.title)
      }

    default:
      return state
  }
}
